import {
  AlertLevel,
  alertLevelSchema,
} from '@/task-manager/entities/alert-level';

export function alertLevelMapper(data: string): AlertLevel {
  return alertLevelSchema.parse(data);
}
